import 'jspdf-autotable'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import { DeletedTransactionsListWrapper } from './deleted-transactions-list/DeletedTransactionsList'


const DeletedTransactionsPage = () => {
  return (
    <>
      <Routes>
        <Route element={<Outlet />}>
          <Route path='deleted-transactions' element={<DeletedTransactionsListWrapper />} />
        </Route>
        <Route index element={<Navigate to='/report' />} />
      </Routes>
    </>
  )
}

export default DeletedTransactionsPage
